import {
  compareDesc,
  formatDistance,
  differenceInHours,
  parseISO,
} from 'date-fns'
import { es, pt, de, fr, it, enGB } from 'date-fns/locale'

import * as F from 'reduker/fp-utils'

const DATE_LOCALES = {
  es,
  pt,
  de,
  fr,
  it,
  en: enGB,
}

export const orderByDate = notifications =>
  notifications.sort((not1, not2) => {
    return compareDesc(parseISO(not1.created_at), parseISO(not2.created_at))
  })

export const addTimeAgoToNotifications = (notifications, locale) => {
  const currentDate = new Date()

  return notifications.map(notification => {
    const notificationDate = notification.created_at

    const timeAgo = formatDistance(parseISO(notificationDate), currentDate, {
      locale: DATE_LOCALES[locale] || es,
    })
    return { ...notification, timeAgo }
  })
}

export const groupNotificationsByDate = notifications => {
  const currentDate = new Date()

  return notifications.reduce(
    (groups, notification) => {
      const notificationDate = notification.created_at

      const interval = differenceInHours(
        currentDate,
        parseISO(notificationDate),
      )

      if (interval > 60) {
        groups.next = [...groups.next, notification]
      } else {
        groups.today = [...groups.today, notification]
      }

      return groups
    },
    { today: [], next: [] },
  )
}

export const formatNotifications = F.pipe(
  addTimeAgoToNotifications,
  groupNotificationsByDate,
)

const markNotificationAsRead = notification => ({
  ...notification,
  viewed: true,
})

export const markAllNotificationsAsRead = F.pipe(
  addTimeAgoToNotifications,
  notifications => notifications.map(markNotificationAsRead),
  groupNotificationsByDate,
)

export const countUnread = notifications =>
  notifications.filter(notification => !notification.viewed).length
